<template>
    <div>

        <div class="cons">
            <div class="bread">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item style="cursor: pointer;" @click.native="handleBack">职业认证</el-breadcrumb-item>
                    <el-breadcrumb-item>{{info.name}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="acTivitiesDetail">
                <div class="flx">
                    <div class="acImg">
                        <img :src="$img(info.pc_avatar)" alt="" />
                    </div>
                    <div class="acInfo">
                        <div class="acNames flx jsb">
                            <div class="acName" v-text="info.name"></div>
                        </div>

                        <div class="labels flx alc">
                            <div class="label" v-for="item,index in info.label" v-text="item.name"></div>
                        </div>

                        <div class="lades single" v-text="info.intro">

                        </div>

                        <div class="infItem flx alc">
                            <div class="infname">价 格</div>
                            <div class="prices flx alc" v-if="info.default_price * 1 > 0">
                                <div class="price1" v-text="`￥${info.default_price}`">

                                </div>
                                <div class="price2" v-text="`￥${info.default_line_price}`">

                                </div>
                            </div>
                            <div class="freePart" v-else>免费</div>
                        </div>

                        <div class="infItem flx" style="margin-bottom: 0 !important;"  v-if="info.spec_type == 20">
                            <div class="infname">科目类型</div>
                            <div class="flx tickets">
                                <div class="ticketItem cursor flx alc" @click="selTicket(item.id,item.money)"
                                    v-for="item,index in info.spec"
                                    :style="ticketId == item.id?'border:1px solid #1677FF' : ''">
                                    <div class="ticketPrice" v-if="item.money * 1 > 0" v-text="`￥${item.money}`"></div>
                                    <div class="ticketPrice" v-else >免费</div>
                                    <div class="ticketName" v-text="item.name"></div>
                                    <img :src="$Localimg('landui.png')" alt="" v-if="ticketId == item.id" />
                                </div>
                            </div>
                        </div>
                        <!-- <div style="justify-content: flex-start;box-sizing: border-box;padding-left: 69px;align-items: center;"
                            class="flx">
                            <span style="font-size: 14px;color: #1F2937;margin-right: 12px;">数量:</span>
                            <el-input-number disabled v-model="num" :min="1" :max="999" :step="1" label="购买数量"
                                size="small"></el-input-number>
                        </div> -->
                    </div>
                </div>

                <div class="btns flx alc">
                    <div class="btnLeft cursor" @click="sings">
                        马上报名
                    </div>
                </div>
                <div class="rules flx alc">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="torules(13)">《职业认证服务购买协议》</b>
                    </div>
                </div>
            </div>

            <div class="actips flx jsb">
                <div class="tipLeft">
                    <div class="acintro">
                        <div class="courseDes">
                            <div class="actitles">
                                <div class="actName">
                                    活动介绍
                                </div>
                                <div class="bheng"></div>
                            </div>
                            <div class="acD" v-html="info.content">

                            </div>
                        </div>

                    </div>
                </div>
                <div class="tipRight">
                    <div class="bottomPart">
                        <div class="bpt">
                            推荐课程
                        </div>
                        <div class="reItem cursor" :style="index == 2?'border:none;margin-bottom:0' : ''"
                            v-for="item,index in info.recomm_zhiye_list" @click="toDetail(item)">
                            <div class="reImg">
                                <img :src="$img(item.pc_avatar)" alt="" />
                            </div>
                            <div class="reInfo">
                                <div class="reName multy2" v-text="item.name"></div>
                                <div class="readdress" v-text="item.label[0].name"></div>
                                <div class="reTitle single" v-text="item.title"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 确认订单弹窗 -->

            <el-dialog title="自定义弹窗标题" :visible.sync="dialogVisible" width="638px">
                <span slot="title">
                    <span style="font-size: 16px;color: #1a1a1a;font-weight: 600;">确认订单</span>
                </span>
                <!-- 这里是完全自定义区域，想写什么写什么 -->
                <div class="custom-dialog-content">
                    <div class="part">
                        <div class="ordernames flx alc">
                            <div class="orderName" v-text="info.name"></div>
                            <div class="orderPrice" v-text="`￥${info.default_price}`">

                            </div>
                        </div>
                        <div class="orderDes" v-text="info.time2">

                        </div>
                    </div>

                    <div class="part">
                        <div class="orderTitle">
                            付款信息
                        </div>
                        <div class="goodsPrice flx jsb">
                            <div class="gpname">
                                商品金额
                            </div>
                            <div class="orderPrice" v-text="`￥${info.default_price}`">

                            </div>
                        </div>
                        <div class="totalPrice flx">
                            合计: <span style="color: #EF4444;font-size: 16px;" v-text="`￥${info.default_price}`"></span>
                        </div>
                    </div>

                    <div class="part">
                        <div class="orderTitle">
                            选择支付方式
                        </div>
                        <div class="pays flx jsb ">
                            <div class="payItem flx alc jsb">
                                <el-radio v-model="paymethod" label="1">支付宝</el-radio>
                                <img :src="$Localimg('alipays.png')" alt="" />
                            </div>
                            <div class="payItem flx jsb alc">
                                <el-radio v-model="paymethod" label="2">微信</el-radio>
                                <img :src="$Localimg('wechats.png')" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="subbtn cursor" @click="suborder">
                        马上支付
                    </div>
                </div>
            </el-dialog>
        </div>
        <wechatpay v-if="showALert" @close="showALert=false" :type="'certification'" :source="'order'" :orderNo="orderNo"
            :codeUrl="codeUrl"></wechatpay>
    </div>
</template>

<script>
    import {
        getcerDetail,
        subre
    } from "@/api/index.js"
    import wechatpay from "@/components/wechatpay.vue"
    import asideAc from "@/components/asidAc.vue"
    export default {
        components: {
            asideAc,
            wechatpay
        },
        data() {
            return {
                paymethod: "",
                dialogVisible: false,
                num: 1,
                cateName: '',
                id: '',
                page: 1,
                bannerList: [],
                recommand: [],
                totals: 0,
                info: {},
                rules: "",
                ticketId: "",
                channel_id: '',
                showALert:false,
                orderNo:"",
                codeUrl:'',
                hasRead:true
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getDetail()
        },
        watch: {
            $route: {
                handler(to, from) {
                    this.id = to.query.id
                    this.getDetail()
                },
                deep: true
            }
        },
        methods: {
            torules(e) {
                let that = this
                that.$router.push({
                    path: '/rules', // 写路由path
                    query: {
                        type: e
                    }
                })
            },
            sings(){
                if(this.hasRead == false){
                    this.$message.warning('请仔细阅读《职业购买协议》')
                    return false
                }
                if(this.info.default_price * 1 > 0){
                    this.dialogVisible = true
                }else{
                    this.suborder()
                }
            },
            toDetail(e) {
                let that = this
                this.$router.push({
                    path: '/cerDetail', // 写路由path
                    query: {
                        id: e.id,
                        type: 1
                    }
                })
            },
            handleBack() {
                if (window.history.length > 1) {
                    this.$router.back()
                } else {
                    this.$router.push('/')
                }
            },
            suborder() {
                let that = this
                let data = {}
                data.id = that.id
                data.spec_id = that.ticketId || ''
                subre(data).then((res) => {
                    if (res.code == 1) {
                        if(res.data.is_pay == 1){
                            that.codeUrl = res.data.code_url
                            that.orderNo = res.data.order_no
                            that.showALert = true
                        }else{
                            this.$router.push({
                                path: '/homeSuccess', // 写路由path
                                query: {
                                    txt: '恭喜您，支付成功!'
                                }
                            })
                        }
                    }
                })
            },
            selTicket(e, money) {
                this.ticketId = e
                this.info.default_price = money
            },
            focusThis() {
                let that = this
                let data = {}
                data.company_id = that.info.company_id
                focusCom(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            colThis() {
                let that = this
                let data = {}
                data.id = that.id
                collectAcs(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            getDetail() {
                let that = this
                let data = that.id
                getcerDetail(data).then((res) => {
                    console.log("res", res)
                    if (res.code == 1) {
                        that.info = res.data
                        if (res.data.spec.length > 0) {
                            that.ticketId = res.data.spec[0].id
                            that.info.default_price = res.data.spec[0].money
                        }
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .rules {
        margin-top: 24px;
        box-sizing: border-box;
        padding-left: 436px;
    }
    
    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }
    
    .el-message {
      z-index: 999999 !important;
    }
    
    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }
    
    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }
    
    
    .subbtn {
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 48px;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
    }

    .payItem img {
        width: 40px;
        height: 40px;
    }

    .payItem {
        width: 255px;
        height: 72px;
        border-radius: 10px;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        padding: 0 18px;
        margin-top: 18px;
    }

    .totalPrice {
        justify-content: flex-end;
        color: #000;
        font-size: 16px
    }

    .goodsPrice {
        padding: 20px 0;
        border-bottom: 1px solid #f6f6f6;
    }

    .orderTitle {
        font-size: 18px;
        color: #000000;
    }

    .orderDes {
        font-size: 12px;
        color: #919296;
        margin-top: 12px;
    }

    .orderName {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        width: 80%;
    }

    .orderPrice {
        font-weight: 600;
        flex: 1;
        font-size: 16px;
        color: #000000;
        text-align: right !important;
    }

    .part {
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 16px;
        margin-bottom: 16px;
    }

    /* vue2 使用 /deep/ 穿透 scoped */
    /deep/ .el-dialog {
        border-radius: 10px;
        /* 整体圆角大小，自行调整 6px/8px/12px/16px */
        overflow: hidden;
        /* 关键：内部内容不会溢出圆角 */
        background: #F3F5F9;
    }

    .reTitle {
        font-size: 14px;
        color: #919296;
    }

    .readdress {
        font-size: 12px;
        color: #007AFF;
        line-height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        background: #F4F9FF;
        display: inline-block;
        margin-bottom: 10px;

    }

    .reName {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 14px;
    }

    .reItem {
        width: 100%;
        border-bottom: 1px solid #ececec;
        margin-bottom: 20px;
    }

    .reInfo {
        text-align: left;
        box-sizing: border-box;
        padding: 12px 0 20px;
    }

    .reImg {
        width: 292px;
        height: 164px;
        overflow-y:hidden
    }

    .reImg img {
        width: 100%;
        /* height: 100%; */
        border-radius: 6px;
    }

    .bpt {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 20px;
        text-align: left;
    }

    .bottomPart {
        background: #ffffff;
        width: 332px;
        box-sizing: border-box;
        padding: 20px;
    }

    .price1 {
        font-weight: 500;
        font-size: 24px;
        color: #EC1414;
        margin-right: 12px;
    }

    .price2 {
        font-size: 18px;
        color: #B1B5B9;
        text-decoration-line: line-through;
        text-transform: none;
    }

    .infname {
        font-weight: 500;
        font-size: 14px;
        color: #888B93;
        margin-right: 14px;
        line-height: 42px;
        width: 56px;
    }

    .acD /deep/ img {
        width: 100%;
        height: auto;
    }

    .lades {
        width: 900px;
        font-size: 14px;
        color: #919296;
        margin-bottom: 24px;
    }

    .labels {
        margin-bottom: 14px;
    }

    .label {
        height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        font-size: 12px;
        color: #007AFF;
        background: #F4F9FF;
        border-radius: 1px 1px 1px 1px;
        line-height: 19px;
        margin-right: 8px;
    }

    .tickets {
        flex-wrap: wrap;
        width: 500px;
    }

    .ticketPrice {
        font-weight: 500;
        font-size: 16px;
        color: #FF0F23;
        margin-right: 6px;
    }

    .ticketName {
        font-size: 12px;
        color: #666666;
    }

    .ticketItem img {
        position: absolute;
        right: 0;
        bottom: 0;
        margin-right: 0 !important;
    }

    .ticketItem {
        margin-bottom: 20px;
        height: 42px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #D9D9D9;
        box-sizing: border-box;
        padding: 10px 20px;
        margin-right: 14px;
        position: relative;
        flex-shrink: 0;
    }

    .comDes {
        font-size: 14px;
        color: #6D6D6D;
        margin-top: 12px;
    }

    .acfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        border: 1px solid rgba(64, 150, 255, 1);
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        color: #007AFF;
        font-weight: 500;
    }

    .unfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        color: #fff;
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        background: #007AFF;
        font-weight: 500;
    }

    .cominfo {
        flex: 1;
    }

    .cominfo img {
        width: 14px;
        height: 14px;
    }

    .comTitle {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 8px;
    }

    .comImg {
        width: 60px;
        height: 60px;
        margin-right: 12px;
    }

    .comImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        margin-right: 12px;
        object-fit: cover;
    }

    .compart {
        width: 100%;
        background: #F7F8F9;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 20px;

    }

    .bheng {
        width: 24px;
        height: 4px;
        background: #007AFF;
        margin: 0 auto;
        margin-top: 8px;
    }

    .actitles {
        display: inline-block;
        position: relative;
        margin-bottom: 20px;
    }

    .actName {
        font-weight: 500;
        font-size: 18px;
        color: #3C464F;

    }

    .acintro {
        background-color: #fff;
        box-sizing: border-box;
        padding: 26px;
        text-align: left;
    }

    .tipLeft {
        width: 1106px;

    }

    .buytip {
        text-align: left;
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 26px;
    }

    .actips {
        margin-top: 16px;
    }

    .btns {
        margin-top: 26px;
        box-sizing: border-box;
        padding-left: 433px;
    }

    .btnRight i {
        margin-right: 6px;
    }

    .btnRight {
        width: 130px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid rgba(64, 150, 255, 1);
        justify-content: center;
        font-weight: 600;
        font-size: 14px;
        color: #007AFF;
    }

    .btnLeft {
        width: 190px;
        height: 40px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        line-height: 40px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 14px;
    }

    .freePart {
        width: 48px;
        height: 26px;
        background: #EFF6FF;
        border-radius: 13px;
        font-size: 12px;
        color: #1E40AF;
        text-align: center;
        line-height: 26px;
    }

    .acNames {
        margin-bottom: 22px;
    }

    .infItem span {
        font-size: 14px;
        color: #1F2937;
    }

    .infItem {
        margin-bottom: 16px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .buyItem {
        font-size: 14px;
        margin-left: 18px;
    }

    .buyItem img {
        width: 20px;
        height: 20px;
    }

    .buyItem span {
        margin-left: 4px;
    }

    .acName {
        font-weight: 600;
        font-size: 18px;
    }

    .acInfo {
        flex: 1;
    }

    .acImg {
        width: 344px;
        height: 194px;
        margin-right: 20px;
        flex-shrink: 0;
    }

    .acImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: cover;
    }

    .acTivitiesDetail {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 26px;
    }

    .cons {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 0;
        border-radius: 10px;
        text-align: left
    }
</style>